import { Component, EventEmitter, OnInit, Output, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { propertyAddressAsyncValidator } from '@shared/validators/property-address.async.validator';
import {
  Address,
  Collection,
  Property,
  PropertyAddForm,
  PropertyCategory,
  PropertyCategoryService,
  PropertyService,
} from 'taxtank-core';
import { takeUntil } from 'rxjs';
import { BaseFormComponent } from '@shared/component/base/base-form.component';

const MESSAGE_ADDED = 'Properties saved';

@Component({
  selector: 'app-property-add-form',
  templateUrl: './property-add-form.component.html',
  styleUrls: ['./property-add-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PropertyAddFormComponent extends BaseFormComponent implements OnInit {
  @ViewChild(FormGroupDirective) formRef: FormGroupDirective;
  @Output() saved: EventEmitter<Property> = new EventEmitter<Property>();
  form: PropertyAddForm;
  categories: Collection<PropertyCategory>;
  now: Date = new Date();
  isAustralian = false;

  private propertyCategoryService = inject(PropertyCategoryService);
  private propertyService = inject(PropertyService);

  ngOnInit(): void {
    super.ngOnInit();
    this.propertyCategoryService.get()
      .pipe(takeUntil(this.destroy$))
      .subscribe((categories: Collection<PropertyCategory>) => {
        this.categories = categories.sortBy('name');
      });

    this.form.get('address').setAsyncValidators(propertyAddressAsyncValidator(this.propertyService.getAll()));
    this.form.get('address').valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((address: Address) => this.isAustralian = address?.country.isAustralia());
  }

  buildForm(): void {
    this.form = new PropertyAddForm();
  }

  save(property: Property): void {
    this.propertyService.post(property).subscribe(property => {
      this.toastService.success(MESSAGE_ADDED);
      this.saved.emit(property);
    });
  }
}
